"use strict";

define('uikit/modules/expandable.menu',['underscore', 'marionette', './menu', '../collections/tree'], function (_, Mn, Menu, TreeView) {
  var MOBILE_REGEX = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/g;
  var isMobile = !!String(navigator.userAgent).match(MOBILE_REGEX);
  var ExpandableMenu = Menu.extend({
    className: Menu.prototype.className + ' expandable',
    triggers: _.extend({}, Menu.prototype.triggers, {
      'mouseenter': 'mouseenter',
      'mouseleave': 'mouseleave'
    }),
    events: {
      'focus .item': 'handleFocusOnItem',
      'blur .item': 'handleBlurOnItem'
    },
    options: _.extend({}, Menu.prototype.options, {
      focused: false,
      hovering: false,
      fixed: true,
      position: 'left',
      pusherContainer: 'body',
      vertical: true,
      expanded: false
    }),
    update: _.extend({}, Menu.prototype.update, {
      focused: false,
      hovering: false,
      expanded: false,
      pusherContainer: false
    }),
    handleFocusOnItem: function handleFocusOnItem(ev) {
      this.focused = true;
    },
    handleBlurOnItem: function handleBlurOnItem(ev) {
      var self = this;
      _.delay(function () {
        if (!self.el.contains(document.activeElement)) {
          self.focused = false;
        }
        ;
      });
    },
    onFirstRender: function onFirstRender() {
      var self = this,
        timeout = null,
        $scroll = $(window);
      Menu.prototype.onFirstRender.apply(this, arguments);
      this.on('mouseenter', function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          self.hovering = true;
        }, 50);
      }).on('mouseleave', function () {
        clearTimeout(timeout);
        this.hovering = false;
        this.focused = false;
      }).on('render', function () {
        this.updateCache();
      }).on('dom:refresh', function () {
        this.updateCache();
      }).on('destroy', function () {
        $scroll.off('scroll', resizeHandler).off('scroll', scrollHandler);
      });
      if (isMobile) {
        this.setupMobileListeners();
      }
      function scrollHandler() {
        window.requestAnimationFrame(function () {
          self.triggerMethod('stick', $scroll.scrollTop());
        });
      }
      function resizeHandler() {
        self.refresh();
      }
      $scroll.on('resize', resizeHandler).on('scroll', scrollHandler);
    },
    setupMobileListeners: function setupMobileListeners() {
      var self = this,
        $el = this.$el,
        $pushers = $(this.pusherContainer).children('.pusher');
      function onPusherPress() {
        self.hovering = false;
      }
      ;
      function onDivClick(ev) {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        onPusherPress();
      }
      ;
      function onDivPressStart(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        _.defer(onPusherPress);
      }
      ;
      function onChangeHovering() {
        $(document.body).append($div);
        $div.css({
          'z-index': Number(self.$el.css('z-index')) - 10
        });
        if (self.hovering && !self.expanded) {
          $div.show();
        } else {
          $div.hide();
        }
      }
      ;
      var $div = $('<div/>').css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.4)'
      }).hide();
      $pushers.on('mousedown', onPusherPress).on('touchstart', onPusherPress);
      $div.on('mousedown', onDivPressStart).on('touchstart', onDivPressStart).on('click', onDivClick);
      $el.on('touchstart', function () {
        self.hovering = true;
      });
      this.on('change:hovering', onChangeHovering).on('destroy', function () {
        $div.remove();
        $pushers.off('mousedown', onPusherPress).off('touchstart', onPusherPress);
      });
      onChangeHovering();
    },
    refresh: function refresh() {
      this.updateCache();
      this.onStick();
      return this;
    },
    updateCache: function updateCache() {
      var $window = $(window),
        win = {
          height: $window.height()
        },
        $container = this.$el.offsetParent(),
        element = {
          margin: {
            top: parseInt(this.$el.css('margin-top'), 10),
            bottom: parseInt(this.$el.css('margin-bottom'), 10)
          },
          offset: this.$el.offset(),
          width: this.$el.outerWidth(),
          height: this.$el.outerHeight()
        },
        container = {
          height: $container.get(0).scrollHeight
        };
      this.cache = {
        fits: element.height < win.height,
        window: {
          height: win.height
        },
        element: {
          margin: element.margin,
          top: element.offset.top - element.margin.top,
          left: element.offset.left,
          width: element.width,
          height: element.height,
          bottom: element.offset.top + element.height
        },
        container: {
          height: container.height
        }
      };
      $(document.body).css('min-height', element.height + 'px');
    },
    updateAttributes: function updateAttributes() {
      var expand = this.getBoolOption('hovering') || this.getBoolOption('expanded') || this.getBoolOption('focused');
      Menu.prototype.updateAttributes.apply(this, arguments);
      this.addClass('expanded', expand);
      this.toggleTreeViews(expand);
    },
    toggleTreeViews: function toggleTreeViews(expand) {
      var self = this;
      if (this._expanded && expand) {
        this._expanded = expand;
        return;
      }
      this._expanded = expand;
      _.each(this.toArray(), function (item) {
        if (item instanceof TreeView && item.collection) {
          var firstNode = item.children.findByIndex(0);
          if (expand) {
            if (firstNode.model._open) {
              item.open(0);
            }
            firstNode.model._open = false;
          } else {
            if (firstNode.$el.find('> .content').hasClass('active')) {
              firstNode.model._open = true;
            }
            item.close(0);
          }
        }
      });
    },
    setElementScroll: function setElementScroll(scroll) {
      if (this.elementScroll == scroll) {
        return;
      }
      this.$el.css('top', -scroll);
    },
    getScrollChange: function getScrollChange(scroll) {
      scroll = scroll || $(window).scrollTop();
      return this.lastScroll ? scroll - this.lastScroll : 0;
    },
    getElementScroll: function getElementScroll(scroll) {
      scroll = scroll || $(window).scrollTop();
      var element = this.cache.element,
        win = this.cache.window,
        delta = this.getScrollChange(scroll),
        maxScroll = element.height - win.height + (this.offset || 0),
        elementScroll = this.getCurrentElementScroll(),
        possibleScroll = elementScroll + delta;
      if (this.cache.fits || possibleScroll < 0) {
        elementScroll = 0;
      } else if (possibleScroll > maxScroll) {
        elementScroll = maxScroll;
      } else {
        elementScroll = possibleScroll;
      }
      return elementScroll;
    },
    getCurrentElementScroll: function getCurrentElementScroll() {
      if (this.elementScroll) {
        return this.elementScroll;
      }
      return Math.abs(parseInt(this.$el.css('top'), 10)) || 0;
    },
    onStick: function onStick(scroll) {
      var cachedPosition = scroll || $(window).scrollTop(),
        cache = this.cache,
        fits = cache.fits,
        container = cache.container,
        element = cache.element,
        win = cache.window,
        maxScroll = element.height - win.height + (this.offset || 0),
        offset = this.offset || 0,
        scroll = {
          top: cachedPosition + offset,
          bottom: cachedPosition + offset + win.height
        },
        elementScroll = this.getElementScroll(scroll.top),
        doesntFit = !fits,
        elementVisible = element.height !== 0;
      var scrollToSet = 0;
      if (elementVisible) {
        if (container.height - scroll.bottom < element.height - win.height - this.getCurrentElementScroll()) {
          scrollToSet = maxScroll;
        } else {
          scrollToSet = elementScroll;
        }
      }
      this.setElementScroll(scrollToSet);
      this.lastScroll = scroll.top;
      this.elementScroll = scrollToSet;
    },
    onAdd: function onAdd(child) {
      if (child instanceof TreeView) {
        this.listenTo(child, 'accordion:change', function () {
          this.refresh();
        });
      }
    }
  });
  return ExpandableMenu;
});

